.settings label textarea {
  min-height: 6rem;
  min-width: 0;
  flex: none;
}

.ipv6 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.settings .ipv6 input {
  width: 1rem;
  height: 1rem;
  margin: 0;
  padding: 0;
  accent-color: var(--accent);
}
